module.exports = __webpack_public_path__ + "img/about-shape-1.1be6f194.svg";